export const REVIEWS_REQUEST = 'REVIEWS_REQUEST'
export const REVIEWS_ERROR = 'REVIEWS_ERROR'
export const REVIEWS_PUSH = 'REVIEWS_PUSH'
export const REVIEWS_TOTAL = 'REVIEWS_TOTAL'
